import React, { FC, InputHTMLAttributes, SyntheticEvent, useState } from "react"
import { useField } from "formik"
import Cleave from "cleave.js/react"
import { checkCreditCardType } from "@lib/functions"
import { BsCreditCard } from "react-icons/bs"
import clsx from "clsx"
import Image from "next/image"

interface FocusEvent<T = Element> extends SyntheticEvent<T> {
  relatedTarget: EventTarget | null
  target: EventTarget & T
}

export const FormikCreditCard: FC<InputHTMLAttributes<HTMLInputElement>> = ({
  name,
  className,
  ...props
}) => {
  const [field, meta] = useField(name ?? "")

  const [isFocused, setIsFocused] = useState(false)

  const errorText = meta.error

  const handleBlur = async (e: FocusEvent<HTMLInputElement>) => {
    field.onBlur(e)
    setIsFocused(false)
  }

  const basicClass =
    "flex items-center px-3 py-2.5 rounded border-2 border-grey-ec w-full gap-2 sm:text-base text-sm"

  function classNameSwitcher() {
    switch (true) {
      case isFocused:
      case field.value && !errorText:
        return clsx(basicClass, "!border-green")
      case errorText !== undefined:
        return clsx(basicClass, "!border-red")
      default:
        return basicClass
    }
  }

  function creditImage() {
    if (field.value && checkCreditCardType(field.value)) {
      return (
        <Image
          src={checkCreditCardType(field.value)}
          alt="field.value"
          width={26}
          height={18}
          objectFit="contain"
        />
      )
    } else {
      return <BsCreditCard />
    }
  }

  return (
    <div className={clsx("relative", className)}>
      <div className={classNameSwitcher()}>
        <Cleave
          {...field}
          options={{ creditCard: true }}
          placeholder={props.placeholder}
          onFocus={() => setIsFocused(true)}
          onBlur={handleBlur}
          className={clsx("w-full", "focus:outline-none focus:shadow-outline")}
        />

        <>{creditImage()}</>
      </div>
      {errorText && <small className="text-red absolute -bottom-4">{errorText}</small>}
    </div>
  )
}
